/**
 * @name: getWxAuth.js
 * @version: 1.0.0
 * @author: bellhe
 */
(function() {
    if ($ === undefined) {
        console.error('weChatShare.js require jQuery');
    }
    function getWxAuth(params, cb) {
        if (SR.data.wxAuth) {
            cb && cb(false, SR.data.wxAuth);
            return;
        }
        if (!params || !params.linkurl) {
            console.warn('can not found share link');
            return;
        }
        $.ajax({
            url: 'https://wxshare.upchina.com/getAuth',
            type: 'GET',
            jsonpCallback: 'callback',
            timeout: 3000,
            data: {
                url: params.linkurl    //url为当前网页的URL，不包含#及其后面部分
            },
            success: function(data) {
                /**
                 * @param {Object} data
                 * @param {string} data.id - 公众号的唯一标识
                 * @param {string} data.ms - 签名
                 * @param {string} data.noncestr - 生成签名的随机字符串
                 * @param {string} data.timestamp - 生成签名的时间戳
                 * @param {string} data.url -当前页面url，不包含#及其后面部分
                 */
                // wxConfigCallBack(data, params); //拿到签名和appid后进行微信配置，调取相关接口
                if (data) {
                    SR.data.wxAuth = data;
                    wx.config({
                        debug: params.debug,            //开启调试模式
                        appId: data.id,                 //必填，公众号的唯一标识
                        timestamp: data.timestamp,      //必填，生成签名的时间戳
                        nonceStr: data.noncestr,        //必填，生成签名的随机串
                        signature: data.ms,             //必填，签名
                        jsApiList: [
                            'onMenuShareTimeline',
                            'onMenuShareAppMessage',
                            'onMenuShareQQ',
                            'onMenuShareQZone',
                            'hideMenuItems',
                            'startRecord',
                            'stopRecord',
                            'onVoiceRecordEnd',
                            'translateVoice',
                        ]
                    });
                    cb && cb(false, data);
                } else {
                    cb && cb(true);
                }
            },
            error: function(err) {
                console.warn(err);
                cb && cb(err);
            }
        });
    }
    window.getWxAuth = getWxAuth;
})();
